import styled from 'styled-components';
import { getBouLinkStyle } from '../../content/texts/bou-link';
import { getTextStyle } from '../../content/texts/bou-text/text-style';
import { BouColor } from '../../global/bou-colors';
import { BouSpacingLevel, fluidHorizontalPadding } from '../../layout/bou-spacing';
import { BouTextAndIcon } from '../bou-text-and-icon';
import { InternalLink } from '../navigation/internal-link';

export const StatusBarItem = styled.div<{ disableClick?: boolean }>`
  ${fluidHorizontalPadding(BouSpacingLevel.TINY)};
  height: 100%;
  display: flex;
  align-items: center;
  border-left: 1px solid ${BouColor.TOOL_BORDER_DARK_GRAY};
  transition: color 0.15s ease-in-out;
  color: ${BouColor.BLACK};
  cursor: ${props => (props.disableClick ? 'default' : 'pointer')};
  &:hover {
    color: ${props => !props.disableClick && BouColor.TOOL_HOVER_DARK_GRAY};
  }
`;
export const StatusBarTextAndIcon = styled(BouTextAndIcon).attrs({ fontWeight: 'normal' })`
  ${getTextStyle({ size: 'xxxxs' })};
`;

export const StatusBarInternalLink = styled(InternalLink)`
  ${getBouLinkStyle(false, undefined, 'lighter')};
`;
